

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PageModal extends Vue {
  name = 'PageModal';

  @Prop({ required: true, type: Boolean }) readonly closeOnWrapperClick: boolean;

  @Prop({ required: true, type: Boolean }) readonly showModal: boolean;

  onWrapperClick(event: Event): void {
    if (this.closeOnWrapperClick) {
      this.$emit('modal-close-action');
    }
  }
}
